import axios from "axios";

import { to3, toLocal } from "../../helpers/api.helper";

export const items = {
    getFlowNFTs: async ({ assetIds }) => {
            const { data } = await axios.get(to3(`items/flow-nfts?itemIds=${assetIds.join(',')}`));
            return data;
    },
};